import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import DriverSelection from './DriverSelection';

function DriverSection(props) {
  const { t } = useTranslation();
  const { handleOnToggle, setFieldValue, shouldDisableForm } = props;
  const {
    Strategic,
    Safety,
    Regulatory,
    CustomerImpact,
    Turnback,
    Warranty,
    StopProduction,
    Standardization,
    CostReduction,
  } = props.values;
  return (
    <Grid item xs={5}>
      <h4>{t('Drivers')}</h4>
      <DriverSelection
        label={t('Strategic')}
        description={t('strategic_driver_description')}
        value={Strategic}
        onChange={val => handleOnToggle('Strategic', val, setFieldValue)}
        disabled={shouldDisableForm}
      />
      <DriverSelection
        label={t('EHS_Impacted')}
        description={t('ehs_driver_description')}
        value={Safety}
        onChange={val => handleOnToggle('Safety', val, setFieldValue)}
        disabled={shouldDisableForm}
      />
      <DriverSelection
        label={t('Regulatory_Issue')}
        description={t('regulatory_driver_description')}
        value={Regulatory}
        onChange={val => handleOnToggle('Regulatory', val, setFieldValue)}
        disabled={shouldDisableForm}
      />
      <DriverSelection
        label={t('External_Customer_Impacted')}
        description={t('external_customer_driver_description')}
        value={CustomerImpact}
        onChange={val => handleOnToggle('CustomerImpact', val, setFieldValue)}
        disabled={shouldDisableForm}
      />
      <DriverSelection
        label={t('Turnbacks_Associated')}
        description={t('turnbacks_driver_description')}
        value={Turnback}
        onChange={val => handleOnToggle('Turnback', val, setFieldValue)}
        disabled={shouldDisableForm}
      />
      <DriverSelection
        label={t('Warranty_Claims_Issued')}
        description={t('warranty_driver_description')}
        value={Warranty}
        onChange={val => handleOnToggle('Warranty', val, setFieldValue)}
        disabled={shouldDisableForm}
      />
      <DriverSelection
        label={t('Potential_Product_Stoppage')}
        description={t('potential_product_stoppage_driver_description')}
        value={StopProduction}
        onChange={val => handleOnToggle('StopProduction', val, setFieldValue)}
        disabled={shouldDisableForm}
      />
      <DriverSelection
        label={t('Standardization')}
        description={t('standardization_driver_description')}
        value={Standardization}
        onChange={val => handleOnToggle('Standardization', val, setFieldValue)}
        disabled={shouldDisableForm}
      />
      <DriverSelection
        label={t('Cost_Reduction')}
        description={t('cost_reduction_driver_description')}
        value={CostReduction}
        onChange={val => handleOnToggle('CostReduction', val, setFieldValue)}
        disabled={shouldDisableForm}
      />
    </Grid>
  );
}
DriverSection.propTypes = {
  values: PropTypes.shape({
    Strategic: PropTypes.string,
    Safety: PropTypes.string,
    Regulatory: PropTypes.string,
    CustomerImpact: PropTypes.string,
    Turnback: PropTypes.string,
    Warranty: PropTypes.string,
    StopProduction: PropTypes.string,
    Standardization: PropTypes.string,
    CostReduction: PropTypes.string,
  }).isRequired,
  handleOnToggle: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  shouldDisableForm: PropTypes.bool.isRequired,
};

export default DriverSection;
